// import MedicalPlanDetails from "../details/medical-plan-details";
import { UserRoundIcon } from "lucide-react";
import NoPreviewCard from "../card/no-preview-card";
import { DiagnosisDetails } from "../details/diagnosis-details";
import { Patient, PatientSessions, PatientDiagnosisResponse } from "../../api/types";

type SessionType = PatientSessions['sessions'][0];

interface MedicalPlanProps {
    diagnosisData?: PatientSessions | PatientDiagnosisResponse;
    userId: string;
    patient?: Patient;
    selectedSession?: SessionType;
    userDoseSpotId?: string;
}

export const DiagnosisOverview = ({ diagnosisData, userId, userDoseSpotId, selectedSession, patient }: MedicalPlanProps) => {
    return (
        <>
            {diagnosisData ? (
                <DiagnosisDetails diagnosis={diagnosisData} userId={userId} patient={patient} userDoseSpotId={userDoseSpotId} selectedSession={selectedSession} />
            ) : (
                <NoPreviewCard
                    Icon={UserRoundIcon}
                    title="No medical plan"
                    description="This patient does not have a medical plan yet."
                    cardTitle="Medical Plan"
                />
            )}
        </>
    );
}